import React, { ReactElement, useCallback } from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import { Loading } from "../../util/Loading";
import { AuthManager } from "../AuthManager";
import { Actions, AuthState, ChildrenArgs, State } from "../types";
import { JobManager } from "./JobManager";
import { LoginMessage } from "./LoginMessage";
import { MaintenanceMessage } from "./MaintenanceMessage";
import { RouteLogin } from "./RouteLogin";
import { SelectJob } from "./SelectJob";

type Props = Readonly<{
  actions: Actions;
  loadRoles: Array<string>;
  render: (args: ChildrenArgs) => ReactElement;
  review: boolean;
  sidebarVisible: boolean;
  state: State;
}>;

export const Content = ({ actions, loadRoles, render, review, sidebarVisible, state }: Props) => {
  const { auth, job, activeJobId } = state;
  let jobContents;
  let indexContents;

  const reviewCheckout = useCallback(async (): Promise<void> => {
    // do nothing in review
  }, []);
  switch (auth.state) {
    case AuthState.loggedIn: {
      jobContents = (
        <JobManager
          addNote={actions.addNote}
          resolveWarning={actions.resolveWarning}
          authState={auth}
          clearActiveJob={actions.clearActiveJob}
          deleteNote={actions.deleteNote}
          fetchNotes={actions.fetchNotes}
          jobState={job}
          activeJobId={activeJobId}
          setActiveJob={actions.setActiveJob}
          loadJob={actions.loadJob}
          loadRoles={loadRoles}
          refreshCheckout={review ? reviewCheckout : actions.refreshCheckout}
          removeJobFromList={actions.removeJobFromList}
          render={render}
          review={review}
          showMessage={actions.showMessage}
          sidebarVisible={sidebarVisible}
          updateNote={actions.updateNote}
        />
      );
      indexContents = (
        <SelectJob
          clearActiveJob={actions.clearActiveJob}
          jobState={job}
          review={review}
          sidebarVisibile={sidebarVisible}
        />
      );
      break;
    }
    case AuthState.initial:
      indexContents = <Loading text="Loading workbench" />;
      jobContents = indexContents;
      break;
    case AuthState.loggingInByForm:
    case AuthState.loggingInByStorage:
      indexContents = <Loading text="Logging into workbench" />;
      jobContents = indexContents;
      break;
    case AuthState.notLoggedIn:
      indexContents = <LoginMessage sidebarVisible={sidebarVisible} />;
      jobContents = <Redirect to="/" />;
      break;
    case AuthState.requestFailed:
      indexContents = <MaintenanceMessage  />;
      jobContents = <Redirect to="/" />;
      break;
  }
  return (
    <Switch>
      <Route path={"/job/:jobId"}>
        <AuthManager actions={actions} state={state}>
          {jobContents}
        </AuthManager>
      </Route>
      <Route path={"/jobs/:jobId"}>
        <AuthManager actions={actions} state={state}>
          {jobContents}
        </AuthManager>
      </Route>
      <Route path="/:authString/job/:jobId">
        <RouteLogin actions={actions} auth={auth} />
      </Route>
      <Route path="/:authString/jobs/:jobId">
        <RouteLogin actions={actions} auth={auth} />
      </Route>
      <Route path="*">
        <AuthManager actions={actions} state={state}>
          {indexContents}
        </AuthManager>
      </Route>
    </Switch>
  );
};
Content.displayName = "Content";
